var map = {
	"./1.jpg": "2cce",
	"./2.jpg": "ecba",
	"./3.jpg": "7df1",
	"./IMG(1).jpg": "3248",
	"./IMG(2).jpg": "7329",
	"./IMG(3).jpg": "2d8e",
	"./IMG(4).jpg": "3144",
	"./IMG(5).jpg": "2e92"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b8f9";